import { RouteTabs } from '@/components/ui/route-tabs';
import type { TradeTab } from '@/features/trading';
import { TRADE_TABS } from '@/features/trading';
import { useLanguage } from '@/i18n/language-hooks';
import { useRoutePrefetch } from '@/lib/queryPrefetch';

interface TradeTabNavProps {
  activeTab: TradeTab;
}

export function TradeTabNav({ activeTab }: TradeTabNavProps) {
  const { t } = useLanguage();
  const prefetch = useRoutePrefetch();

  return (
    <RouteTabs
      ariaLabel={t('trade.tabs.label')}
      activeId={activeTab}
      onPrefetch={prefetch}
      items={TRADE_TABS.map((tab) => ({
        id: tab,
        to: `/trade/${tab}`,
        label: t(`trade.tabs.${tab}`),
      }))}
    />
  );
}
